<template>
  <div id="delete-done">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-intro.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :pageTitle="headerPageTitle"
    />
    <div class="done-wrapper">
      <div class="done-container">
        <h1 style="margin-top:0">{{ $t('acc.delete.done.title') }}</h1>
        <p v-html="$t('acc.delete.done.content1')"></p>
        <p v-html="$t('acc.delete.done.content2')"></p>
      </div>
    </div>
    <div class="absolute-bottom">
      <form-button
        :btnName="buttonName"
        @parentCall="this.goAccLogin"
      />
    </div>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import FormButton from '@/components/FormButton';

export default {
  name: 'delete-done',
  mixins: [
    common,
  ],
  data() {
    return {
      headerPos: 'on-top',
      headerPageTitle: this.$i18n.t('acc.delete.header'),

      buttonName: this.$i18n.t('acc.delete.done.button'),

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompHeader,
    FormButton,
  },
  computed: {
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="../../scss/acc-done.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-delete-done.vue